import { Link } from 'react-router-dom';
import { ShieldX, SearchX } from 'lucide-react';
import { permMeta } from '@dental-flow/rbac';
import { EmptyState } from '@/components/ui';
import { useTranslation } from 'react-i18next';

/**
 * Shown when a route is gated behind a permission the user does not hold.
 *
 * It names the missing permission. "Access denied" on its own sends the user
 * to support; naming it sends them to whoever can grant it.
 */
export function ForbiddenPage({ permission }: { permission?: string }) {
  const { t } = useTranslation('common');
  const label = permission ? (permMeta(permission)?.label ?? permission) : null;
  return (
    <>
      <h1 className="sr-only">{t('accesRefuzat')}</h1>
      <EmptyState
        icon={<ShieldX size={32} />}
        title={t('nuAiAccesLa')}
        description={
          label
            ? `Îți lipsește permisiunea „${label}”. Cere-i administratorului clinicii să ți-o acorde.`
            : t('cereIAdministratoruluiClinicii')
        }
        action={
          <Link to="/" className="btn btn--secondary btn--md">
            {t('inapoiLaPaginaPrincipala')}
          </Link>
        }
      />
    </>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation('common');
  return (
    <>
      <h1 className="sr-only">{t('paginaNuExista')}</h1>
      <EmptyState
        icon={<SearchX size={32} />}
        title={t('paginaNuExista')}
        description={t('linkulPoateFiVechi')}
        action={
          // Un singur element: un buton pus într-un link erau două ținte de
          // tastatură, iar eticheta spunea „calendar" pentru „/".
          <Link to="/calendar" className="btn btn--secondary btn--md">
            {t('inapoiLaCalendar')}
          </Link>
        }
      />
    </>
  );
}
